import { render, staticRenderFns } from "./FbPagesBox.vue?vue&type=template&id=6127308b&"
import script from "./FbPagesBox.vue?vue&type=script&lang=js&"
export * from "./FbPagesBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports